import { render, staticRenderFns } from "./MaterialInputPlan.vue?vue&type=template&id=a58f030a&scoped=true&"
import script from "./MaterialInputPlan.vue?vue&type=script&lang=js&"
export * from "./MaterialInputPlan.vue?vue&type=script&lang=js&"
import style0 from "./MaterialInputPlan.vue?vue&type=style&index=0&id=a58f030a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58f030a",
  null
  
)

export default component.exports